module OnlineDPR.Application.Client.ChartComponent

open Fable.Core.JsInterop
open Fable.Core
open Fable.React

type RCom = ReactElementType<obj>

module Props =

    type DataLabelOptions = {
        align : string
        anchor : string
        backgroundColor : string
        borderRadius : int
        color : string
        display: bool
        offset : int;
        rotation : int;
        formatter : decimal -> obj -> string;
    }

    type LineDataSet = {
        label : string
        backgroundColor : string
        borderColor : string
        borderCapStyle : string
        borderDash : obj []
        borderWidth : int
        fill : bool
        data : decimal option []
        datalabels : DataLabelOptions
    }

    type LineChartData = {
        labels : string []
        datasets : LineDataSet []
    }

    type DoughnutDataSet = {
        label : string
        backgroundColor : string []
        borderColor : string []
        borderCapStyle : string
        borderDash : obj []
        borderWidth : int
        fill : bool
        data : obj []
    }

    type DoughnutChartData = {
        labels : string []
        datasets : DoughnutDataSet []
    }

    type BarDataSet = {
        label : string
        backgroundColor : string
        borderColor : string
        borderCapStyle : string
        borderDash : obj []
        borderWidth : int
        fill : bool
        data : decimal option []
        datalabels : DataLabelOptions
    }

    type BarChartData = {
        labels : string []
        datasets : BarDataSet []
    }

    type ChartAxisTicks = {
        beginAtZero : bool
    }

    type ChartAxis = {
        ticks : ChartAxisTicks
    }

    type ChartScales = {
        yAxes : ChartAxis []
    }

    type ChartLegend = {
        display : bool
        position : string
    }

    type ChartOptions = {
        maintainAspectRatio : bool
        responsive : bool
        scales : ChartScales
        legend : ChartLegend
    }


    type ILineChartProperties =
        interface end

    [<RequireQualifiedAccess>]
    type LineChartProperties =
    | Key of obj
    | Title of string
    | Width of float
    | Height of float
    | Options of ChartOptions
    | Data of LineChartData
    | OnClick of (unit -> unit)
        interface ILineChartProperties

    type IDoughnutChartProperties =
        interface end

    [<RequireQualifiedAccess>]
    type DoughnutChartProperties =
    | Key of obj
    | Title of string
    | Width of float
    | Height of float
    | Options of ChartOptions
    | Data of DoughnutChartData
    | OnClick of (unit -> unit)
        interface IDoughnutChartProperties

    type IBarChartProperties =
        interface end

    [<RequireQualifiedAccess>]
    type BarChartProperties =
    | Key of obj
    | Title of string
    | Width of float
    | Height of float
    | Options of ChartOptions
    | Data of BarChartData
    | OnClick of (unit -> unit)
        interface IBarChartProperties

import "datalabels" "chartjs-plugin-datalabels"

let Line: RCom = import "Line" "react-chartjs-2"

let line (props:Props.ILineChartProperties list) children : ReactElement =
    ReactElementType.create Line (keyValueList CaseRules.LowerFirst props) children

let Doughnut: RCom = import "Doughnut" "react-chartjs-2"

let doughnut (props:Props.IDoughnutChartProperties list) children : ReactElement =
    ReactElementType.create Doughnut (keyValueList CaseRules.LowerFirst props) children

let Bar: RCom = import "Bar" "react-chartjs-2"

let bar (props:Props.IBarChartProperties list) children : ReactElement =
    ReactElementType.create Bar (keyValueList CaseRules.LowerFirst props) children